import styled from 'styled-components';
import { ReactComponent as RawCheckmarkPurpleSVG } from '../../../../assets/icons/checkmark_purple.svg';

export const IconCheckmarkPurple = styled(RawCheckmarkPurpleSVG)``;
